import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  JbActionModule,
  JbDatePickerModule,
  JbErrorModule,
  JbFormFieldContainerModule,
  JbSrOnlyModule,
} from 'jb-component-library';

import { CityPairSelectorModule } from '../city-pair-selector';
import { MultiCityRowComponent } from './multi-city-row.component';

const MODULES = [
  CommonModule,
  ReactiveFormsModule,
  JbDatePickerModule,
  CityPairSelectorModule,
  JbErrorModule,
  JbFormFieldContainerModule,
  JbSrOnlyModule,
  JbActionModule,
];

const DECLARATIONS = [MultiCityRowComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...DECLARATIONS],
})
export class MultiCityRowModule {}
